export const RepairOrderClosingLabel = "Repair Order Closing";
export const NewLabel = "New";

export enum Measurements {
    RUN_OUT = 'RUN OUT',
    AXIAL_PLAY = 'AXIAL PLAY',
    TOLERANCE = 'TOLERANCE',
    GRADIENT = 'GRADIENT',
  }